import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Drawer, Popover, Space } from "antd";

import { SearchAction } from "../../../store/actions";

import BasicSearchItems from "./sidebar/basicsreachitems";
import Searchbarloader from "../../loader/searchbarloader";

import {
  getStringParam,
  setNumberParam,
  setStringParam,
} from "../../../utils/urlsearchparams";
import useScreenSize from "../../../utils/usescreensize";

import images from "../../../assets";

import "./styles.css";

const SearchField = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const screenSize = useScreenSize();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const { quickMatches, isQuickLoading } = useSelector(
    (state) => state?.search
  );
  const gender = useSelector((state) => state.profile?.profile?.gender);

  const [matchedUsers, setMatchedUsers] = useState([]);
  const isSearchResults = location?.pathname?.includes("/search-results");
  const [search, setSearch] = useState(
    isSearchResults
      ? getStringParam(
          searchParams,
          "searchText",
          getStringParam(searchParams, "searchtext", "")
        )
      : ""
  );
  const [isFocused, setIsFocused] = useState(false);
  const [open, setOpen] = useState(false);
  const [basicSearchMenu, setBasicSearchMenu] = useState(false);
  const [popoverWidth, setPopoverWidth] = useState(null);

  const searchBarRef = useRef(null);

  useEffect(() => {
    if (location?.pathname?.includes("/basic-search")) {
      setBasicSearchMenu(true);
    } else {
      setBasicSearchMenu(false);
    }
  }, [location?.pathname]);

  useEffect(() => {
    setMatchedUsers(quickMatches);
  }, [quickMatches]);

  useEffect(() => {
    const searchText = getStringParam(
      searchParams,
      "searchText",
      getStringParam(searchParams, "searchtext", "")
    );
    if (!isSearchResults) {
      return;
    }
    if (searchText !== search) {
      setSearch(searchText);
    }
  }, [isSearchResults, searchParams.toString()]);

  useEffect(() => {
    if (search?.length > 2) {
      const payload = {
        searchText: search,
        gender,
      };
      if (gender) {
        dispatch(SearchAction.quickSearch(payload));
      }
    }
  }, [dispatch, gender, search]);

  useEffect(() => {
    const updatePopoverWidth = () => {
      if (searchBarRef.current) {
        setPopoverWidth(searchBarRef.current.offsetWidth - 20);
      }
    };
    updatePopoverWidth();
    window.addEventListener("resize", updatePopoverWidth);
    return () => window.removeEventListener("resize", updatePopoverWidth);
  }, [isFocused]);

  const handleSearch = (e) => {
    setSearch(e);
    if (isSearchResults) {
      const params = new URLSearchParams(searchParams);
      setStringParam(params, "searchText", e);
      params.delete("searchtext");
      setNumberParam(params, "page", 1);
      setSearchParams(params, { replace: true });
    }
  };

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  const searchContent = (
    <div className="w-full">
      {isQuickLoading ? (
        <div style={{ margin: "0px auto", padding: "20px" }}>
          <Searchbarloader />
        </div>
      ) : (
        <>
          {search?.length <= 2 ? (
            <div>
              <h4
                style={{ padding: "20px", fontSize: "14px", fontWeight: "500" }}
              >
                Type at least three characters to search
              </h4>
              <hr />
              <div className="see-all-text-container stand-search-mobile">
                <p
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#8993A4",
                  }}
                >
                  Use{" "}
                  <span
                    className="purple-text underline text-secondary cursor-pointer"
                    onClick={() => {
                      showDrawer();
                      navigate("/basic-search");
                    }}
                  >
                    Standard Search
                  </span>{" "}
                  instead
                </p>
              </div>
            </div>
          ) : matchedUsers.length > 0 ? (
            <div style={{ maxHeight: "400px", overflowX: "auto" }}>
              {matchedUsers?.map((user, index) => (
                <div
                  key={index}
                  className="result-items"
                  onClick={() =>
                    navigate(`/view-profile/${user?.username}?from=quickSearch`)
                  }
                >
                  <img
                    src={
                      user?.profilePicture && user?.profilePicture !== "null"
                        ? user?.profilePicture
                        : user?.gender === "male"
                        ? images.defaultMaleIcon
                        : images.defaultFemaleIcon
                    }
                    className="result-items-image"
                    alt="user"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src =
                        user?.gender === "male"
                          ? images?.defaultMaleIcon
                          : images?.defaultFemaleIcon;
                    }}
                  />
                  <div className="result-items-text-container text-wrap">
                    <p style={{ fontSize: "14px", fontWeight: "400" }}>
                      {user.firstName} {user.lastName}
                    </p>
                    <p style={{ fontSize: "12px", color: "#8993A4" }}>
                      {user.stateProvince}, {user.country}
                    </p>
                  </div>
                </div>
              ))}
              <hr />
              <div className="see-all-text-container">
                <p
                  className="purple-text underline text-secondary cursor-pointer"
                  onClick={() => {
                    const params = isSearchResults
                      ? new URLSearchParams(searchParams)
                      : new URLSearchParams();
                    setStringParam(params, "searchText", search);
                    params.delete("searchtext");
                    setNumberParam(params, "page", 1);
                    if (location?.pathname?.includes("/search-results")) {
                      setSearchParams(params);
                    } else {
                      navigate(`/search-results?${params.toString()}`);
                    }
                  }}
                >
                  See All
                </p>
              </div>
            </div>
          ) : (
            <div>
              <h4
                style={{ padding: "20px", fontSize: "16px", fontWeight: "500" }}
              >
                No users found
              </h4>
              <hr />
              <div className="see-all-text-container">
                <p
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#8993A4",
                  }}
                >
                  Use{" "}
                  <span
                    className="purple-text"
                    onClick={() => {
                      showDrawer();
                      navigate("/basic-search");
                    }}
                    style={{ color: "#BA0060", textDecoration: "underline" }}
                  >
                    Standard Search
                  </span>{" "}
                  instead
                </p>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );

  return (
    <div className="header-searchbar-container" ref={searchBarRef}>
      {screenSize.width < 1023 && (
        <Drawer
          className="standard-search-drawer"
          closable={false}
          mask={false}
          placement="left"
          onClose={onClose}
          open={open}
          extra={<Space />}
        >
          <BasicSearchItems onClick={onClose} setOpen={setOpen} />
        </Drawer>
      )}
      <Popover
        content={searchContent}
        trigger="click"
        arrow={false}
        overlayInnerStyle={{
          padding: "0px",
          borderTopLeftRadius: "0px",
          borderTopRightRadius: "0px",
          width: popoverWidth || "auto",
        }}
        open={isFocused}
        overlayStyle={{
          top:
            screenSize.width < 1023
              ? props?.promotionheader
                ? "118px"
                : "58px"
              : props?.promotionheader
              ? "125px"
              : "65px",
        }}
        // onOpenChange={handleDropdownVisibleChange}
        placement="bottomLeft"
      >
        <div
          className={
            isFocused ? "header-searchbar-focused" : "header-searchbar"
          }
        >
          <img src={images.headerSearch} alt="search" />
          <input
            type="text"
            placeholder="Search"
            className="header-searchbar-input"
            value={search}
            onChange={(e) => handleSearch(e.target.value)}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setTimeout(() => setIsFocused(false), 500)}
          />
          {search && (
            <img
              src={images.clearSearchfield}
              alt="clear"
              onClick={() => handleSearch("")}
            />
          )}
          {!search && isFocused && (
            <img
              src={images.searchCross}
              alt="clear"
              onClick={() => setIsFocused(false)}
            />
          )}
        </div>
      </Popover>
    </div>
  );
};

export default SearchField;
